import { Service } from "./types/service";

export const defaultService: Service = {
    description: '',
    baseValue: 0,
    createdAt: new Date(),
    createdBy: '',
    updatedAt: null,
    updatedBy: null
};